import store from "@/commons/store"
import { mutationTypes, actionTypes } from "@/commons/constants"

const MSG_REDIRECIONAMENTO_PERFIL = "As credenciais informadas não tem acesso ao perfil selecionado. Estamos redirecionando você para a área correta. Por favor, tente novamente."

const ROTAS_LIBERADAS_FORNECEDOR_SOMENTE_CREDENCIAMENTO = [
    "credenciamentoBusca",
    "PaginaNaoAutorizado",
    "selecionarDominio",
    "RedirecionarEditarUsuario"
]

class RouterGuards {
    async condicoes(to, from, next) {
        try {
            await this.garantirUsuarioCarregado()
        } catch (e) {
            // silêncio: fallback para estado atual
        }
        this.validarPermissoes(to, next)
    }

    async garantirUsuarioCarregado() {
        const user = (store.state && store.state.loki && store.state.loki.user) || {}
        const domainType = (user && (user.domainType || (user.dominio && user.dominio.tipo) || (user.domain && user.domain.type) || (user.currentDomain && user.currentDomain.type))) || ""
        const normDomainType = domainType ? String(domainType).toUpperCase() : ""
        const userType = user && user.type ? String(user.type).toUpperCase() : ""

        const productId = store.state && store.state.loki && store.state.loki.product && store.state.loki.product.id
        if (!productId) return

        const needsHydration = !normDomainType || (userType === 'EXTERNO' && normDomainType !== 'FORNECEDOR')
        if (!needsHydration) return

        if (!this._hydratingPromise) {
            this._hydratingPromise = store.dispatch(actionTypes.BUSCAR_USUARIO_LOGADO)
                .catch(() => {})
                .finally(() => { this._hydratingPromise = null })
        }
        await this._hydratingPromise
        }

        obterTipoDominio() {
            const user = (store.state && store.state.loki && store.state.loki.user) || {}
            const dt = user && (user.domainType || (user.dominio && user.dominio.tipo) || (user.domain && user.domain.type) || (user.currentDomain && user.currentDomain.type))
            return (dt && String(dt).toUpperCase()) || ""
        }

        validarPermissoes(to, next) {

        const user = store.state.loki.user
        const authorities = (user && user.authorities) || []

        const userTypeNorm = user && user.type ? String(user.type).toUpperCase() : ""
        const contexto = {
            isFornecedor: this.obterTipoDominio() === "FORNECEDOR" || userTypeNorm === "EXTERNO",
            possuiPermissao: (perm) => this.possuiPermissao(authorities, perm)
        }

        if (this.tratarCredenciamentoDadosGerais(to, next, contexto)) return

        if (this.tratarCredenciamentoPropostaDadosGerais(to, next, contexto)) return

        if (this.tratarFornecedorSomenteCredenciamento(to, next, contexto)) return

        if (this.validarAuthoritiesPagina(to, next, authorities)) return

        if (this.validarPermissaoEdicao(to, next, contexto)) return

        next()
    }

    possuiPermissao(authorities, authority) {
        return authorities.some(a => a.name === authority && a.hasAccess)
    }

    tratarCredenciamentoDadosGerais(to, next, { isFornecedor, possuiPermissao }) {
        if (!to || to.name !== "CredenciamentoAtualizacaoDadosGerais") return false

        const id = this.getLicitacaoId(to)

        if (isFornecedor) {
            return this.redirecionarComMensagem(next, {
                path: `/credenciamento/${id}/proposta/dadosGerais`
            })
        }

        if (!possuiPermissao("Credenciamento.Visualizar")) {
            return this.redirecionarComMensagem(next, { name: "PaginaNaoAutorizado" })
        }

        return false
    }

    tratarCredenciamentoPropostaDadosGerais(to, next, { isFornecedor, possuiPermissao }) {
        if (!to || to.name !== "credenciamentoFornecedorDadosGerais") return false

        const id = this.getLicitacaoId(to)

        if (!isFornecedor && possuiPermissao("Credenciamento.Visualizar")) {
            return this.redirecionarComMensagem(next, {
                path: `/credenciamento/${id}/dadosGerais`
            })
        }

        if (!isFornecedor && !possuiPermissao("Credenciamento.Visualizar")) {
            return this.redirecionarComMensagem(next, { name: "PaginaNaoAutorizado" })
        }

        return false
    }

    tratarFornecedorSomenteCredenciamento(to, next, { isFornecedor, possuiPermissao }) {
        const somenteCredenciamento = isFornecedor &&
            possuiPermissao("Credenciamento.Fornecedor") &&
            !possuiPermissao("Licitacao.Visualizar")

        if (!somenteCredenciamento || this.ehRotaLiberadaSomenteCredenciamento(to)) return false

        next({ name: "credenciamentoBusca" })
        return true
    }

    ehRotaLiberadaSomenteCredenciamento(to) {
        const rotas = (to && to.matched) || []

        return ROTAS_LIBERADAS_FORNECEDOR_SOMENTE_CREDENCIAMENTO.includes(to && to.name) ||
            rotas.some(rota => rota.name === "credenciamentoFornecedor")
    }

    validarAuthoritiesPagina(to, next, authorities) {
        if (!to || !to.meta || !to.meta.authorities) return false

        const possuiAlguma = to.meta.authorities.some(auth =>
            this.possuiPermissao(authorities, auth)
        )

        if (!possuiAlguma) {
            this.redirecionar(to, next, authorities)
            return true
        }

        return false
    }

    validarPermissaoEdicao(to, next, { possuiPermissao }) {

        if (!to || !to.query || to.query.edicao !== "true") return false

        const permissao = this.identificarModuloPermissaoEdicao(to)

        if (permissao && !possuiPermissao(permissao)) {
            this.redirecionar(to, next, store.state.loki.user.authorities)
            return true
        }

        return false
    }

    getLicitacaoId(to) {
        const paramId = to && to.params && to.params.id
        if (paramId) return paramId

        const match = to && to.path && to.path.match(/^\/credenciamento\/([^/]+)/)

        return (match && match[1]) || ""
    }

    identificarModuloPermissaoEdicao(to) {

        const path = to.path.toLowerCase()

        if (path.startsWith("/credenciamento")) return "Credenciamento.Editar"
        if (path.startsWith("/licitacoes")) return "Licitacao.Atualizar"

        return null
    }

    redirecionar(to, next, authorities) {

        const temCredenciamento = authorities.some(a =>
            (a.name === "Credenciamento.Visualizar" || a.name === "Credenciamento.Editar" || a.name === "Credenciamento.Fornecedor") && a.hasAccess
        )

        const temLicitacao = authorities.some(a =>
            a.name === "Licitacao.Visualizar" && a.hasAccess
        )

        if (temCredenciamento && !temLicitacao) {
            return this.redirecionarComMensagem(next, { name: "credenciamentoBusca" })
        }

        return this.redirecionarComMensagem(next, { name: "PaginaNaoAutorizado" })
    }

    redirecionarComMensagem(next, destino) {
        this.notificarRedirecionamento()
        next(destino)
        return true
    }

    notificarRedirecionamento() {
        setTimeout(() => {
            store.commit(
                mutationTypes.MOSTRAR_MENSAGEM_ERRO,
                MSG_REDIRECIONAMENTO_PERFIL
            )
        })
    }
}

export default new RouterGuards()
